/** Evaluation grain labels — keep aligned with backend RuleDryRunService.normalizeProcessingCategory */

export const PROCESSING_CATEGORY_OPTIONS = [
  {
    value: 'session-based',
    label: 'Per session',
    description: 'Evaluate each gaming session (carded or merged uncarded sit) using session totals.',
  },
  {
    value: 'interval-based',
    label: 'Per 15‑minute interval',
    description: 'Evaluate each meter attribution interval (gaming_session_interval_attribution) — catches patterns within a single 15‑min window.',
  },
  {
    value: 'cumulative',
    label: 'Member rollup',
    description: 'Roll up member activity over a time window (daily stats / transaction rollup).',
  },
]

/** Legacy rule builders (Transaction/Gaming) use session | interval | cumulative form values. */
export const PROCESSING_CATEGORY_LEGACY_FORM_OPTIONS = [
  { value: 'session', label: 'Per session' },
  { value: 'interval', label: 'Per 15‑minute interval' },
  { value: 'cumulative', label: 'Member rollup' },
]

/** Map legacy UI values (session, interval) to API storage values. */
export function normalizeProcessingCategoryForSave(value) {
  const k = String(value || '').toLowerCase().replace(/_/g, '-')
  if (k === 'session' || k === 'session-based') return 'session-based'
  if (k === 'interval' || k === 'interval-based' || k === 'transaction-based') return 'interval-based'
  if (k === 'cumulative') return 'cumulative'
  return value || 'session-based'
}

/** Map stored rule.processing_category to form select value. */
export function processingCategoryFromBackend(value) {
  const k = String(value || '').toLowerCase().replace(/_/g, '-')
  if (k === 'cumulative') return 'cumulative'
  if (k === 'interval' || k === 'interval-based' || k === 'transaction-based') return 'interval-based'
  return 'session-based'
}

export function formatProcessingCategoryLabel(processingCategory) {
  const k = String(processingCategory || '').toLowerCase().replace(/_/g, '-')
  if (k === 'cumulative') return 'Member rollup'
  if (k === 'interval' || k === 'interval-based' || k === 'transaction-based') {
    return 'Per 15‑minute interval'
  }
  if (k === 'session-based' || k === 'session') return 'Per session'
  return processingCategory ? String(processingCategory) : '—'
}

export function processingCategoryExplanation(processingCategory) {
  const k = String(processingCategory || '').toLowerCase().replace(/_/g, '-')
  if (k === 'cumulative') {
    return 'Rolled-up over a time window (evaluation grain: member rollup).'
  }
  if (k === 'interval' || k === 'interval-based' || k === 'transaction-based') {
    return 'Each 15‑minute meter interval is evaluated separately (evaluation grain: per 15‑minute interval). Use CashIn, Turnover, or *_alloc fields in AUD.'
  }
  if (k === 'session-based' || k === 'session') {
    return 'Evaluated on each gaming session using merged session totals (evaluation grain: per session).'
  }
  return null
}
